import { c as _c } from "react/compiler-runtime";
import { cloneElement, useId } from 'react';
function ClipMask(t0) {
  const $ = _c(13);
  const {
    children,
    clipPath,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const id = `mask_${useId()}`;
  if (Array.isArray(children)) {
    throw new Error("A ClipMask may have only one child element");
  }
  const styleClipPath = `url(#${id})`;
  let t2;
  if ($[0] !== children || $[1] !== styleClipPath) {
    t2 = cloneElement(children, {
      style: {
        clipPath: styleClipPath,
        WebkitClipPath: styleClipPath
      }
    });
    $[0] = children;
    $[1] = styleClipPath;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const clippedChild = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      pointerEvents: "none"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== clipPath || $[5] !== id) {
    t4 = <defs><clipPath id={id} clipPathUnits="objectBoundingBox" transform="scale(0.01 0.01)">{clipPath}</clipPath></defs>;
    $[4] = clipPath;
    $[5] = id;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== className || $[8] !== t4) {
    t5 = <svg preserveAspectRatio="none" viewBox="0 0 100 100" aria-hidden="true" className={className} style={t3}>{t4}</svg>;
    $[7] = className;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== clippedChild || $[11] !== t5) {
    t6 = <>{t5}{clippedChild}</>;
    $[10] = clippedChild;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export default ClipMask;